/**
 * Load and start tracking with Google analytics for logged-out users.
 *
 * @param {object} context
 * @param {object} context.$config
 * @param {object} context.app
 */
export default function ({ $config, app }) {
    if (!$config?.googleTagManagerKey) {
        return
    }
    window.onNuxtReady(() => {
        window.dataLayer = window.dataLayer || []

        const accountId = app.store.getters['global/account']?.databaseId
        const accountType = app.store.getters['global/accountType']
        const accountCountry = app.store.getters['global/userCountry']
        const accountLocale = app.i18n.locale
        const isExcludedFromTracking =
            app.store.getters['global/account']?.isExcludedFromTracking

        if (app.$helpers.isLoggedIn) {
            window.dataLayer.push({
                accountId,
                accountType,
                accountCountry,
                accountLocale,
                isExcludedFromTracking: isExcludedFromTracking
                    ? 'true'
                    : 'false',
            })
        } else {
            window.dataLayer.push({
                accountId: null,
                accountType: null,
                accountCountry: null,
                accountLocale: null,
                isExcludedFromTracking: 'false',
            })
        }

        ;(function (w, d, s, l, i) {
            w[l] = w[l] || []
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
            const f = d.getElementsByTagName(s)[0]
            const j = d.createElement(s)
            const dl = l !== 'dataLayer' ? '&l=' + l : ''
            j.async = true
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
            f.parentNode.insertBefore(j, f)
        })(window, document, 'script', 'dataLayer', $config.googleTagManagerKey)
    })
}
